import React from 'react';
import _ from 'lodash';
import { Card, CardHeader, CardContent, Button, Modal, Stack, Typography, Box } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const MatchInformation = ({ open, handleClose, matchInfo }) => (
  <Modal
    open={open}
    onClose={handleClose}
  >
    <Card sx={{ ...style, width: '30vw' }}>
      <CardHeader
        title="Informacje"
      />
      <CardContent>
        <Stack direction="column" spacing={1}>
          <Typography variant="body1">Liczba niedopasowanych pozycji: <span style={{ fontWeight: 'bold' }}>{matchInfo.mismatched}</span></Typography>
          <Typography variant="body1">Liczba utworzonych paragonów: <span style={{ fontWeight: 'bold' }}>{matchInfo.created_receipts}</span></Typography>
          <Typography variant="body1">Liczba nr. IKB z innego sezonu niż wybrany: <span style={{ fontWeight: 'bold' }}>{matchInfo.mismatched_season}</span></Typography>
        </Stack>
        <Box textAlign="center" marginTop={2}>
          <Button variant="contained" onClick={handleClose}>Zamknij</Button>
        </Box>
      </CardContent>
    </Card>
  </Modal>
);

export default MatchInformation;
